import React from 'react';
export function Footer() {
  return <footer className="bg-aurora-warm py-6 px-5 text-center" data-id="element-10">
      <p className="text-[13px] text-aurora-gray-light" data-id="element-11">
        Aurora, gestão financeira para confeiteiras e artesãs.
      </p>
      <a href="https://myaurora.com.br" target="_blank" rel="noopener noreferrer" className="text-[13px] text-aurora-pink font-medium hover:underline mt-1 inline-block" data-id="element-12">
        myaurora.com.br
      </a>
    </footer>;
}